import { api } from '@/api';
import type {
  DeviceDetails,
  DeviceDetailInfo,
  DeviceDetailCompany,
  ServiceContractSummary,
} from '../types';

// Raw shapes as returned by the platform API. device/company are snake_case while
// serviceContract is already camelCase, so we normalise everything to camelCase below.
interface RawDeviceDetails {
  device: DeviceDetailInfo;
  company: DeviceDetailCompany;
  serviceContract: ServiceContractSummary | null;
}

// fetchDeviceDetails loads the full device details by UUID and maps the snake_case
// platform payload into the camelCase shape used throughout the webapp.
export async function fetchDeviceDetails(deviceId: string): Promise<DeviceDetails> {
  const raw = await api.get<RawDeviceDetails>(`/v1/devices/${deviceId}/details`);
  return {
    device: raw.device,
    company: raw.company,
    serviceContract: raw.serviceContract,
  };
}

